/* eslint-disable import/prefer-default-export */
import { BIControlPanel } from '../interfaces/BIControlPanel';

export const ptBR: BIControlPanel = {
  title: 'Painel de Controle BI',
  tabs: {
    invoiceValue: 'Valor da Fatura BI',
    approvalStatus: 'Aprovação de Status',
    parameterRules: 'Parâmetros BI',
  },
  filters: {
    placeholder: 'Selecione',
    noData: 'Nenhum resultado encontrado',
    endText: 'Todos os itens foram carregados',
    expandedTooltip: 'Ocultar opções de pesquisa',
    collapsedTooltip: 'Expandir opções de pesquisa',
    panelExpanded: 'Painel aberto',
    panelCollapsed: 'Painel fechado',
    financialGroupRequired: 'Grupo financeiro*',
    financialGroup: 'Grupo financeiro',
    contract: 'Contrato',
    subcontract: 'Subcontrato',
    carrier: 'Operadora',
    competency: 'Competência',
  },
  table: {
    rowsPerPage: 'Linhas por página',
    of: 'de',
    invoiceValue: 'Valor da fatura',
    invoicePageTotal: 'Total da página',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    lastUpdateDate: 'Data da última atualização',
    updateUser: 'Usuário de atualização',
  },
  messages: {
    parametersPanelLoadError: 'Ocorreu um erro ao carregar o painel de parâmetros.',
    approvalPanelLoadError: 'Ocorreu um erro ao carregar o painel de aprovação.',
    additionalFiltersLoadError: 'Ocorreu um erro ao carregar os filtros adicionais.',
    filterOptionsLoadError: 'Ocorreu um erro ao buscar as opções do filtro.',
    filtersClearError: 'Ocorreu um erro ao limpar os filtros.',
    dataSearchError: 'Ocorreu um erro ao pesquisar os dados.',
    tableDataSearchError: 'Ocorreu um erro ao buscar os dados da tabela do BI.',
    statusUpdateError: 'Ocorreu um erro ao atualizar o status.',
    pageChangeError: 'Ocorreu um erro ao trocar a página.',
    pageSizeChangeError: 'Ocorreu um erro ao alterar a quantidade de linhas.',
  },
  parameterRules: {
    filters: {
      carrier: 'Operadora',
      carrierRequired: 'Operadora*',
      paymentModel: 'Modelo',
      financialGroup: 'Grupo Financeiro',
      contract: 'Contrato',
      status: 'Status',
    },
    table: {
      levelType: 'Tipo de Nível',
      levelOption: 'Opção do Nível',
      paymentModel: 'Modelo',
      rule: 'Regra',
      ruleStatus: 'Status da Regra',
      actions: 'Ações',
      active: 'Ativo',
      inactive: 'Inativo',
      noData: 'Nenhum item foi encontrado',
      newRule: 'Nova Regra',
    },
    actions: {
      edit: 'Editar',
      ruleHistory: 'Histórico da regra',
      parameterHistory: 'Histórico do parâmetro',
      activateRule: 'Ativar regra',
      deactivateRule: 'Inativar regra',
    },
    levels: {
      CARRIER: 'Operadora',
      FINANCIAL_GROUP: 'Grupo Financeiro',
      CONTRACT: 'Contrato',
    },
    paymentModels: {
      PRE_PAGAMENTO: 'Pré Pagamento',
      POS_PAGAMENTO: 'Pós Pagamento',
    },
    parameterTypes: {
      LIFE_COUNT: 'Contagem de Vidas',
      COMPETENCY: 'Exibição de Competência',
    },
    lifeCountRules: {
      PC: 'PC',
      FATURA: 'Fatura',
      DADO_FECHADO: 'Dado Fechado',
    },
    competencyTypes: {
      MENSAL: 'Mensal',
      QUINZENAL: 'Quinzenal',
    },
    wizard: {
      createTitle: 'Nova Regra',
      editTitle: 'Editar Regra',
      step1: 'Selecione um Nível',
      step2: 'Configurar Parâmetro',
      levelType: 'Tipo de Nível *',
      carrier: 'Operadora *',
      financialGroup: 'Grupo Financeiro *',
      contract: 'Contrato *',
      paymentModels: 'Modelo *',
      parametersSectionTitle: 'Detalhes do parâmetro',
      parametersSectionDescription: 'Selecione o tipo de parâmetro e informe o valor que será aplicado à regra.',
      parameterType: 'Tipo',
      parameterValue: 'Valor',
      active: 'Ativo',
      addParameter: 'Adicionar novo parâmetro',
      back: 'Voltar Etapa anterior',
      cancel: 'Cancelar',
      advance: 'Avançar',
      save: 'Salvar Regra',
    },
    messages: {
      loadError: 'Ocorreu um erro ao carregar os dados.',
      filterOptionsLoadError: 'Ocorreu um erro ao buscar as opções do filtro.',
      filtersClearError: 'Ocorreu um erro ao limpar os filtros.',
      searchError: 'Ocorreu um erro ao pesquisar os dados.',
      statusUpdateError: 'Ocorreu um erro ao atualizar o status.',
      saveError: 'Ocorreu um erro ao salvar a regra.',
      duplicateParameterType: 'Já existe um parâmetro ativo deste tipo para esta regra.',
      duplicateRule: 'Já existe uma regra ativa para este nível e escopo.',
      historyLoadError: 'Ocorreu um erro ao buscar o histórico.',
      parameterRequired: 'Adicione ao menos um parâmetro à regra.',
    },
    history: {
      revTypes: {
        ADD: 'Criação',
        MOD: 'Alteração',
        DEL: 'Exclusão',
      },
      attributes: {
        active: 'Status',
        level: 'Tipo de Nível',
        carrierId: 'Operadora',
        financialGroupId: 'Grupo Financeiro',
        contractId: 'Contrato',
        paymentModels: 'Modelo',
        parameterType: 'Tipo',
        lifeCountRule: 'Valor',
        competencyType: 'Valor',
        ruleId: 'Regra',
      },
    },
  },
};
